import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { getPropostaOmni, reprovarOmni } from 'services/api-omni';
import { StatusContent } from 'ui/styled';
import { isOmni } from 'utils/validators';
const { selectColors, exposeStrapiError } = require('utils');

export const OmniActionButton = ({ row, user, setModal, init }) => {
  const bank = row?.proposta_financeira?.propostas_banco[0]?.banco;
  const idPropostaApi =
    row?.proposta_financeira?.propostas_banco[0]?.id_proposta_api;
  const [parecer, setParecer] = useState(!(isOmni(bank) && idPropostaApi));
  const [isLoading, setIsLoading] = useState(true);
  const verificarStatus = useCallback(async () => {
    let reprova = false;
    if (!isOmni(bank) || !idPropostaApi) {
      setIsLoading(false);
      return;
    }
    try {
      const res = await getPropostaOmni(idPropostaApi, row.distributorId);
      if (!exposeStrapiError(res)) {
        const status = res?.dadosProposta?.status;
        if (status !== 'ESPERA' && status !== undefined) {
          setParecer(true);
          if (status === 'REPROVADA' || status === 'CANCELADA') {
            setParecer(false);
            const id = row?.id;
            const payload = {
              bankProposal: row?.proposta_financeira?.propostas_banco[0]?.id,
              omniId: parseInt(idPropostaApi),
            };
            await reprovarOmni(id, payload);
            reprova = true;
            toast.info(
              `A proposta ${row?.proposta_financeira?.id} esta com o status ${status} na OMNI. Caso nenhum outro banco esteja em análise, ela será cancelada.`
            );
          }
          return { mudou: true, status: res?.dadosProposta?.status, reprova };
        }
      }
      return { mudou: false, status: res?.dadosProposta?.status, reprova };
    } catch (err) {
      console.error('Erro Omni:', err);
      return { mudou: false, status: 'ESPERA', reprova: false };
    } finally {
      setIsLoading(false);
    }
  }, [idPropostaApi, bank, row]);

  useEffect(() => verificarStatus(), [verificarStatus]);

  const handleClique = async () => {
    if (!idPropostaApi) {
      setModal({
        type: 'bureau',
        dados: row,
        origem: 'negocios',
        reload: () => init(),
      });
      //const teste = await reenviaOmni(row?.proposta_financeira?.id);
      //console.log(teste);
      //toast.info('Reenviado para Omni aguarde');
      return;
    }
    if (parecer) {
      if (row?.status === 'Motor' && user?.banking) {
        setModal({
          type: 'bureau',
          dados: row,
          origem: 'negocios',
          reload: () => init(),
        });
      }
      return;
    }
    setIsLoading(true);
    const mudouParaParecer = await verificarStatus();
    if (!mudouParaParecer.mudou) {
      toast.info(
        `A proposta ${row?.proposta_financeira?.id} está EM ESPERA na Omni. Aguardando gerar o Birô de Crédito.`
      );
    } else if (!mudouParaParecer.reprova) {
      toast.info(
        `A proposta está com o Birô de Crédito gerado e foi definida pela Omni como: ${mudouParaParecer.status}.`
      );
    }
  };

  return (
    <StatusContent
      color={
        !idPropostaApi
          ? selectColors('negado')
          : parecer
            ? selectColors(row?.status)
            : selectColors('em analise')
      }
      style={{
        cursor: isLoading || !idPropostaApi ? 'not-allowed' : 'pointer',
        pointerEvents: isLoading || !idPropostaApi ? 'none' : 'auto',
        opacity: isLoading || !idPropostaApi ? 0.6 : 1,
      }}
      onClick={handleClique}
    >
      {!idPropostaApi
        ? 'Sem OmniID'
        : isLoading
          ? 'Aguarde'
          : parecer
            ? 'Parecer'
            : 'Verificar'}
    </StatusContent>
  );
};
